import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8001'

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para adicionar token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

let isRefreshing = false
let refreshSubscribers = []

function onRefreshed(newToken) {
  refreshSubscribers.forEach(cb => cb(newToken))
  refreshSubscribers = []
}

function onRefreshFailed() {
  refreshSubscribers = []
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  window.location.href = '/login'
}

// Interceptor para tratar erros
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      // Sem token — não há nada a renovar
      const token = localStorage.getItem('token')
      if (!token) {
        onRefreshFailed()
        return Promise.reject(error)
      }

      if (isRefreshing) {
        // Aguarda o refresh em andamento e retenta
        return new Promise((resolve, reject) => {
          refreshSubscribers.push((newToken) => {
            if (newToken) {
              originalRequest.headers.Authorization = `Bearer ${newToken}`
              resolve(api(originalRequest))
            } else {
              reject(error)
            }
          })
        })
      }

      isRefreshing = true
      try {
        const res = await axios.post(
          `${BASE_URL}/auth/refresh`,
          null,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        const newToken = res.data.access_token
        localStorage.setItem('token', newToken)
        onRefreshed(newToken)
        originalRequest.headers.Authorization = `Bearer ${newToken}`
        return api(originalRequest)
      } catch (refreshError) {
        // Só desloga se o refresh retornou 401 (token inválido de verdade)
        // Erros de rede (sem response) mantêm a sessão — pode ser instabilidade
        if (refreshError.response?.status === 401) {
          onRefreshFailed()
        } else {
          // Rede/timeout/5xx: cancela subscribers sem deslogar
          refreshSubscribers.forEach(cb => cb(null))
          refreshSubscribers = []
        }
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(error)
  }
)

export default api
